/**
 * Leranio Logo bileşenleri.
 * Kaynak: /public/logos/{app-icon,logo-dark,logo-mono}.png
 *
 * Brand Guide v1.0 (2026) - Kurallar:
 *  - Minimum clear space: sembolün yüksekliğinin en az %20'si (her yön).
 *  - Oranlar bozulmaz; renkler değiştirilmez; efekt/gölge/redraw yasak.
 *  - Düşük kontrastlı zeminlerde kullanılmaz — light/dark otomatik switch.
 *
 * Clear-space padding otomatik olarak size prop'undan hesaplanır (size * 0.20).
 */

const APP_ICON = "/logos/app-icon.png";
const LOGO_DARK = "/logos/logo-dark.png";   // koyu zemin için (renkli ikon + beyaz yazı)
const LOGO_MONO = "/logos/logo-mono.png";   // açık zemin için (siyah ikon + siyah yazı)

/**
 * Kare sembol logo (favicon, app icon, sidebar).
 * @param size    - CSS px cinsinden yükseklik/genişlik (default 40).
 * @param rounded - Tailwind border-radius sınıfı (default rounded-xl).
 * @param strict  - true ise brand guide %20 clear-space padding uygulanır (basılı/kurumsal kullanım).
 */
export function LogoIcon({ size = 40, className = "", rounded = "rounded-xl", strict = false }) {
  const pad = strict ? Math.round(size * 0.2) : 0;
  const outer = size + pad * 2;
  return (
    <span
      className={`inline-flex items-center justify-center shrink-0 ${className}`}
      style={{ width: outer, height: outer, padding: pad }}
      aria-label="Leranio"
    >
      <img
        src={APP_ICON}
        alt="Leranio"
        width={size}
        height={size}
        className={`${rounded} shrink-0 select-none`}
        style={{ width: size, height: size }}
        draggable={false}
      />
    </span>
  );
}

/**
 * Wordmark (yazılı) logo — header/hero için tam kimlik.
 * @param height - CSS px cinsinden yükseklik (default 40).
 * @param theme  - "auto" | "light" (koyu bg için) | "dark" (açık bg için).
 * @param strict - Brand guide %20 clear-space padding.
 */
export function LogoWordmark({ height = 40, className = "", theme = "auto", strict = false }) {
  const pad = strict ? Math.round(height * 0.2) : 0;
  const wrapStyle = strict ? { padding: pad } : undefined;
  const commonProps = {
    alt: "Leranio",
    style: { height },
    className: "select-none",
    draggable: false,
  };
  if (theme === "auto") {
    return (
      <span className={`inline-flex items-center ${className}`} style={wrapStyle} aria-label="Leranio">
        <img src={LOGO_MONO} {...commonProps} className={`${commonProps.className} block dark:hidden`} />
        <img src={LOGO_DARK} {...commonProps} className={`${commonProps.className} hidden dark:block`} />
      </span>
    );
  }
  const src = theme === "light" ? LOGO_DARK : LOGO_MONO;
  return (
    <span className={`inline-flex items-center ${className}`} style={wrapStyle} aria-label="Leranio">
      <img src={src} {...commonProps} />
    </span>
  );
}

export default LogoIcon;
